import { useTranslation } from 'react-i18next';
import Footer from '../home/components/Footer';

export default function About() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <a href="/" className="flex items-center gap-3 cursor-pointer">
              <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-purple-600 rounded-lg flex items-center justify-center">
                <i className="ri-wifi-line text-white text-xl"></i>
              </div>
              <span className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                ConnectNow
              </span>
            </a>
            <nav className="flex items-center gap-6">
              <a href="/" className="text-gray-600 hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap">
                {t('packages')}
              </a>
              <a href="/about" className="text-blue-600 font-semibold whitespace-nowrap">
                {t('aboutUs')}
              </a>
              <a href="/contact" className="text-gray-600 hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap">
                {t('contactUs')}
              </a>
            </nav>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative py-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-600/10 to-purple-600/10"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <div className="text-center">
            <h1 className="text-5xl font-bold text-gray-900 mb-6">
              {t('aboutUs')}
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              نحن منصة رائدة في توفير خدمات الإنترنت للمناطق النائية بطرق دفع مرنة وآمنة
            </p>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">رؤيتنا ورسالتنا</h2>
              <p className="text-lg text-gray-600 mb-4">
                نسعى لتوفير خدمات إنترنت عالية الجودة للجميع، بغض النظر عن موقعهم الجغرافي. نؤمن بأن الوصول إلى الإنترنت حق أساسي يجب أن يكون متاحًا للجميع.
              </p>
              <p className="text-lg text-gray-600">
                من خلال تقنياتنا المتقدمة وشراكاتنا مع أفضل مزودي خدمات الدفع الإلكتروني، نجعل الاتصال بالإنترنت سهلاً وآمنًا ومتاحًا للجميع.
              </p>
            </div>
            <div className="relative h-96 rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/48f19048d41f9b2dcdffef3e263ee480.jpg"
                alt="Our Mission"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">قيمنا الأساسية</h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-shield-check-line text-blue-600 text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">الأمان والثقة</h3>
              <p className="text-gray-600">
                نحمي بياناتك ومعاملاتك المالية باستخدام أحدث تقنيات التشفير والأمان
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-customer-service-2-line text-purple-600 text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">خدمة العملاء</h3>
              <p className="text-gray-600">
                فريقنا متاح على مدار الساعة لمساعدتك وحل أي مشكلة قد تواجهها
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-rocket-line text-green-600 text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">الابتكار المستمر</h3>
              <p className="text-gray-600">
                نطور خدماتنا باستمرار لنوفر لك أفضل تجربة إنترنت ممكنة
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 bg-gradient-to-br from-blue-600 to-purple-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-5xl font-bold text-white mb-2">50K+</div>
              <div className="text-blue-100">مستخدم نشط</div>
            </div>
            <div>
              <div className="text-5xl font-bold text-white mb-2">99.9%</div>
              <div className="text-blue-100">وقت التشغيل</div>
            </div>
            <div>
              <div className="text-5xl font-bold text-white mb-2">24/7</div>
              <div className="text-blue-100">دعم فني</div>
            </div>
            <div>
              <div className="text-5xl font-bold text-white mb-2">4</div>
              <div className="text-blue-100">طرق دفع</div>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-4">فريقنا</h2>
          <p className="text-center text-gray-600 mb-12 max-w-2xl mx-auto">
            فريق من المحترفين المتفانين في تقديم أفضل خدمة لعملائنا
          </p>
          <div className="grid md:grid-cols-4 gap-8">
            {[
              { name: 'أحمد محمد', role: 'المدير التنفيذي', image: 'Professional business executive in modern office, confident leader, formal business attire, clean background, professional headshot style, natural lighting, corporate photography&width=300&height=300&seq=team-1' },
              { name: 'فاطمة علي', role: 'مديرة التقنية', image: 'Professional female technology director, confident tech leader, business casual attire, modern office background, professional headshot, natural lighting, corporate style&width=300&height=300&seq=team-2' },
              { name: 'عمر حسن', role: 'مدير العمليات', image: 'Professional operations manager, confident business professional, formal attire, clean office background, professional headshot photography, natural lighting&width=300&height=300&seq=team-3' },
              { name: 'سارة أحمد', role: 'مديرة خدمة العملاء', image: 'Professional customer service manager, friendly and approachable, business attire, modern office setting, professional headshot, natural lighting, corporate photography&width=300&height=300&seq=team-4' }
            ].map((member, index) => (
              <div key={index} className="text-center">
                <div className="w-48 h-48 mx-auto mb-4 rounded-full overflow-hidden shadow-lg">
                  <img
                    src={`https://readdy.ai/api/search-image?query=${member.image}&orientation=squarish`}
                    alt={member.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-1">{member.name}</h3>
                <p className="text-gray-600">{member.role}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-br from-blue-50 to-purple-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">
            هل أنت مستعد للبدء؟
          </h2>
          <p className="text-xl text-gray-600 mb-8">
            انضم إلى آلاف المستخدمين الذين يثقون بنا لتوفير خدمات الإنترنت
          </p>
          <a
            href="/"
            className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white px-8 py-4 rounded-full font-semibold hover:shadow-lg transition-all cursor-pointer whitespace-nowrap"
          >
            اختر باقتك الآن
            <i className="ri-arrow-left-line"></i>
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
